import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../utils/Utils.js';
import DataCollectionAdd from '../shared/DataCollectionAdd.js';
import '../lists/ListItems.css';
import { formatListTitle } from './listCode';

const AddListItemForm = ({ lists, categories, defaultListId }) => {
  const { t } = useTranslation();
  const defaultList = (defaultListId && lists.find(l => l._id === defaultListId))
    || lists.find(l => l.is_default)
    || lists[0];

  return (
    <>
      <select name="list_id" required defaultValue={defaultList?._id || ''}>
        <option value="" disabled>{t('lists_select_list')}</option>
        {lists.map(l => (
          <option key={l._id} value={l._id}>
            {formatListTitle(l, t)}{l.is_default ? ' ★' : ''}
          </option>
        ))}
      </select>
      <input
        type="text"
        name="text"
        placeholder={t('lists_item_placeholder')}
        required
        autoFocus
      />
      <select name="category" defaultValue="">
        <option value="">{t('lists_no_category')}</option>
        {categories.map(c => (
          <option key={c._id || c.name} value={c.name}>{c.name}</option>
        ))}
      </select>
      <input type="number" name="cost" min="0" step="0.01" placeholder={t('lists_cost_optional')} />
    </>
  );
};

// New items start pending, so no finance transaction yet; the cost is used
// when the item is marked purchased (Trello 8mOHyvSN).
const getBodyFromForm = (formData) => {
  const cost = Number(formData.get('cost'));
  return JSON.stringify({
    ...(cost > 0 ? { cost } : {}),
    list_id:   formData.get('list_id'),
    text:      formData.get('text'),
    category:  formData.get('category') || '',
    status:    'pending',
    source:    'dashboard',
    created_at: new Date().toISOString(),
  });
};

const AddListItem = ({ onSuccess, defaultListId, onBack }) => {
  const { t } = useTranslation();
  const [lists, setLists]           = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    Fetch(
      '/api/data/lists.lists',
      'GET', null,
      (data) => setLists(data || []),
      () => {}
    );
    Fetch(
      '/api/data/lists.categories',
      'GET', null,
      (data) => setCategories(data || []),
      () => {}
    );
  }, []);

  return (
    <>
      {onBack && (
        <button className="list-items-back" onClick={onBack}>
          ← {t('back')}
        </button>
      )}
      <DataCollectionAdd
        collection="lists.items"
        getBodyFromForm={getBodyFromForm}
        formElements={() => (
          <AddListItemForm
            lists={lists}
            categories={categories}
            defaultListId={defaultListId}
          />
        )}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default AddListItem;
